import { render, staticRenderFns } from "./checkRiskJiaohuZhangqian.vue?vue&type=template&id=074e5a54&scoped=true&"
import script from "./checkRiskJiaohuZhangqian.vue?vue&type=script&lang=js&"
export * from "./checkRiskJiaohuZhangqian.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskJiaohuZhangqian.vue?vue&type=style&index=0&id=074e5a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e5a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074e5a54')) {
      api.createRecord('074e5a54', component.options)
    } else {
      api.reload('074e5a54', component.options)
    }
    module.hot.accept("./checkRiskJiaohuZhangqian.vue?vue&type=template&id=074e5a54&scoped=true&", function () {
      api.rerender('074e5a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/checkRiskJiaohuZhangqian.vue"
export default component.exports